import { GET_PUBLICACOES_SUCCESS, GET_PUBLICACOES_PENDENTES, GET_PUBLICACOES_FAIL, UPDATE_PUBLICACAO_SUCCESS, UPDATE_PUBLICACAO_FAIL, GET_PUBLICACAO_SUCCESS, GET_PUBLICACAO_FAIL, GET_PUBLICACAO, NEXT_PAGE, PREVIOUS_PAGE, FIRST_PAGE, LAST_PAGE } from "./actionTypes"

const INIT_STATE = {
  publicacoes: [],
  filtros: {},
  error: {},
  totalCount: 0,
  totalPages: 0,
  currentPageIndex: 1,
  loading: false,
}

const publicacoes = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PUBLICACOES_PENDENTES:
      return {
        ...state,
        filtros: action.payload,
      }

    case GET_PUBLICACOES_SUCCESS:
      const { publicacoes, totalCount, totalPages, currentPageIndex } = action.payload;
      return {
        ...state,
        publicacoes: publicacoes,
        totalCount: totalCount,
        totalPages: totalPages,
        currentPageIndex: currentPageIndex,
        loading: false,
        error: {}
      }

    case GET_PUBLICACOES_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case GET_PUBLICACAO:
      return {
        ...state,
        loading: true,
      };

    case GET_PUBLICACAO_SUCCESS:
      return {
        ...state,
        publicacao: action.payload,
      };

    case GET_PUBLICACAO_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_PUBLICACAO_SUCCESS:
      return {
        ...state,
        publicacoes: state.publicacoes.map(publicacao =>
          publicacao.id.toString() === action.payload.id.toString()
            ? { publicacao, ...action.payload }
            : publicacao
        ),
      };

    case UPDATE_PUBLICACAO_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case NEXT_PAGE:
      return {
        ...state,
        currentPageIndex: state.currentPageIndex + 1,
      };

    case PREVIOUS_PAGE:
      return {
        ...state,
        currentPageIndex: state.currentPageIndex - 1
      };

    case FIRST_PAGE:
      return {
        ...state,
        currentPageIndex: 0,
      };

    case LAST_PAGE:
      return {
        ...state,
        currentPageIndex: state.totalPages - 1
      };

    default:
      return state
  }
}

export default publicacoes
